import React from 'react';
import { Link } from 'gatsby';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';


import Logo from '../../assets/images/icon.png';

import Container from '../Container';
import Sidebar from '../Sidebar/Sidebar';

export const solutions = [
  {
    items: [
      {
        name: 'Commercial Support for Jitsi',
        link: '/solutions/commercial-support-for-jitsi',
      },
      {
        name: 'Custom Communication Systems',
        link: '/solutions/custom-communication-systems',
      },
      {
        name: 'Consultation for WebRTC and Jitsi Solutions',
        link: '/solutions/consultation-for-webrtc-projects',
      },
    ],
  },
  {
    items: [
      {
        name: 'WebRTC Infrastructure as Code',
        link: '/solutions/webrtc-infrastructure-as-code',
      },
      {
        name: 'WebRTC Monitoring',
        link: '/solutions/webrtc-monitoring',
      },
      {
        name: 'WebRTC Load Testing',
        link: '/solutions/webrtc-load-testing',
      },
      {
        name: 'WebRTC Architectures',
        link: '/solutions/webrtc-architecture',
      },
    ],
  },
  {
    heading: '',
    items: [
      {
        name: 'Machine Images',
        link: '/solutions/machine-images',
      },
      {
        name: 'WebRTC Infrastructure Auditing',
        link: '/solutions/webrtc-infrastructure-auditing',
      },
    ],
  },
];

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const navItems = () => {
    return (
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/services">Services</Link>
        </li>
        <li>
          <Button
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            className="nav-button"
          >
            Solutions
          </Button>
        </li>
        <li>
          <Link to="/products">Products</Link>
        </li>
        <li>
          <Link to="/pricing">Pricing</Link>
        </li>
        <li>
          <a href="https://meetrix.io/blog/#hs-chat-open" target="blank">
            Resources
          </a>
        </li>
        {/* <li>
              <Link to="/">Get Connected</Link>
            </li> */}
        <li>
          <Link className="yellow-button" to="/contact-us">
            Contact Us
          </Link>
        </li>
      </ul>
    );
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  return (
    <header>
      <Container>
        <div className="logo-wrapper">
          <Link to="/">
            <img className="logo" src={Logo} alt="meetrix-logo" />
          </Link>
        </div>
        <div className="large-screen small-font">{navItems()}</div>

        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="end"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="small-screen"
        >
          <MenuIcon />
        </IconButton>
        {/* className="small-screen" */}
        <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      </Container>
      <Popper
        open={open}
        role={undefined}
        transition
        disablePortal
        className="dropdown"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: 'center bottom' }}
          >
            <ClickAwayListener onClickAway={handleClose}>
              <div className="dropdown-items-wrapper">
                <div className="blur-background" />
                <Grid container className="grid-container">
                  {solutions.map((category) => {
                    return (
                      <Grid xs={4}>
                        {/* <h4 className="headings">{category.heading}</h4> */}
                        {category.items.map((inside) => {
                          return (
                            // inside.externalLink ? <a href={inside.externalLink} target="_blank" rel="noopener">{inside.name}</a> :<Link to={inside.link}>{inside.name}</Link>
                            <Link className="small-font" to={inside.link}>{inside.name}</Link>
                          );
                        })}
                        <br />
                      </Grid>
                    );
                  })}
                </Grid>
              </div>
            </ClickAwayListener>
          </Grow>
        )}
      </Popper>
    </header>
  );
};

export default Header;
